export default "__VITE_ASSET__CDPhioJi__"